export default __webpack_public_path__ + "static/media/footer-instagram.dc521f4c.svg";